import React, { useEffect } from 'react';
import '@trp-beacon-ui-kit/foundation/style-tokens/css/variables.css';
import '@trp-beacon-ui-kit/foundation/fonts/fonts.css';
import { Box, Grid, Typography } from '@trp-individual-investor-adv-svc/ii-prosp-components';

import { PsBeaconButton } from '../shared/BeaconRegister';
import { Content } from '../shared/Content';
import PastPlanTile from './Tiles/PastPlanTile';
import HubPageBase from './HubPageBase';
import InsightsTile from './Tiles/InsightsTile';
import ServiceInfoCard from '../../containers/ServiceInfoCard';
import { dispatchOverlayLoad } from '../shared/Analytics';
import { showModal } from '../../Utils';

const PlanExpiredPage = ({ state, dispatch }) => {
    const [serviceError, setServiceError] = React.useState(false);
    const [buttonSize, setButtonSize] = React.useState(
        window.innerWidth <= 960 ? '100%' : 'inherit'
    );
    const [open, setOpen] = React.useState(false);

    const popupAlertText = Content.planBlockedAlert.contentText;
    const popupAlertTitle = Content.planBlockedAlert.contentTitle;

    const handlePopupClose = () => {
        setOpen(false);
    };

    const openAccountSelectionModal = () => {
        showModal('acct-selection');
        dispatchOverlayLoad('Primary Consent 1 Modal');
    };

    useEffect(() => {
        const smallScreenSize = window.matchMedia('(max-width: 960px)');
        const handleResize = () => {
            setButtonSize(smallScreenSize.matches ? '100%' : 'inherit');
        };
        smallScreenSize.addEventListener('change', handleResize);
        return () => smallScreenSize.removeEventListener('change', handleResize);
    }, []);

    return (
        <>
            <HubPageBase
                state={state}
                dispatch={dispatch}
                serviceError={serviceError}
                popUpError={open}
                popupAlertText={popupAlertText}
                popupClose={handlePopupClose}
                popupAlertTitle={popupAlertTitle}>
                <Box className="b-container-content" sx={{ inlineSize: 'unset !important' }}>
                    <Grid sx={{ paddingTop: '64px' }} container rowSpacing={2}>
                        <Grid item cols={12}>
                            <Typography
                                id="plan-expired-page-title"
                                sx={{ paddingBottom: '24px' }}
                                type="headline" serif loose scale={400}>
                                Let&apos;s build your financial plan
                            </Typography>
                            <Typography
                                id="plan-expired-page-content"
                                loose light>
                                The time frame to receive your personalized financial plan has
                                expired. Please update your questionnaire and schedule an
                                appointment with a financial advisor so you may agree to the Terms
                                of Service and receive your plan.
                            </Typography>
                            <Box id="continue-button-container" sx={{ paddingTop: '24px' }}>
                                <PsBeaconButton
                                    id="continue-button"
                                    scale="jumbo"
                                    onClick={openAccountSelectionModal}
                                    style={{ width: buttonSize }}>
                                    Continue
                                </PsBeaconButton>
                            </Box>
                        </Grid>
                    </Grid>
                    {state?.hasDocuments && (
                        <Grid container sx={{ paddingTop: '120px' }}>
                            <Grid item cols={12} lg={6} xl={4}>
                                <PastPlanTile
                                    state={state}
                                    setServiceError={setServiceError}
                                    setPopupError={setOpen}
                                    fullHeight
                                />
                            </Grid>

                            <Grid cols={12} lg={6} xl={4} item>
                                <InsightsTile buttonSize={buttonSize} />
                            </Grid>
                        </Grid>
                    )}
                </Box>
            </HubPageBase>
            <Box>
                <ServiceInfoCard />
            </Box>
        </>
    );
};

export default PlanExpiredPage;
